export default {
      id: "icon--wear-flops-usage",
      viewBox: "0 0 29 30",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--wear-flops-usage",
      toString: function () {
        return this.url;
      }
    }